import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { RequestSchedulingResponse } from "@/types";

async function cancelScheduling(
  request: { id: string; outcome: "canceled" | "no_show"; reason: string; expected_revision: number }
): Promise<RequestSchedulingResponse> {
  const response = await httpRequest.post<RequestSchedulingResponse>(
    `/schedulings/canceled/${request.id}`, request
  );
  return response.data;
}

export function useCancelSchedulingMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelScheduling,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedulings"] });
    },
  });
}
